import React, { MouseEvent, ReactNode } from 'react';
import dynamic from 'next/dynamic';
import { Anchor } from './ButtonShare.styles';

export interface ButtonShareProps {
  icon?: 'whatsapp' | 'mail' | 'print';
  className?: string;
  href?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void | undefined;
}

const MailIcon = dynamic(() => import('@/components/icons/MailIcon/MailIcon'));
const PrintIcon = dynamic(() => import('@/components/icons/PrintIcon/PrintIcon'));
const WhatsAppSimpleIcon = dynamic(() => import('@/components/icons/WhatsAppIcon/WhatsAppSimpleIcon'));

const ButtonShare = React.forwardRef<HTMLAnchorElement, React.HTMLProps<HTMLAnchorElement> & ButtonShareProps>(
  function ButtonShare({ icon, href, children, onClick, ...props }: ButtonShareProps, propRef) {
    return (
      <Anchor href={href} onClick={onClick} {...props} ref={propRef}>
        {icon === 'whatsapp' && <WhatsAppSimpleIcon width={32} color={'secondary_500'} />}
        {icon === 'mail' && <MailIcon />}
        {icon === 'print' && <PrintIcon />}
      </Anchor>
    );
  }
);

export default ButtonShare;
